import { render, staticRenderFns } from "./bg-progress.vue?vue&type=template&id=1381b624"
import script from "./bg-progress.vue?vue&type=script&lang=ts"
export * from "./bg-progress.vue?vue&type=script&lang=ts"
import style0 from "./bg-progress.vue?vue&type=style&index=0&id=1381b624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports